<template>
  <main-content>
    <div class="col-12 col-md-8">
      <div class="card">
        <div class="card-header border-0"></div>
        <div class="card-body">
          <h4>Listening link</h4>
          <hr />

          <p
            class="text-mute"
          >Listening links allow people to listen to your radio. All of the links below offer a different listening quality.</p>

          <div class="card">
             <div class="card-header">
                <div class="card-title">Embedded Player 1 (Share Link)</div>
             </div>

            <div class="card-body">
              <a target="_blank" :href="baseEmbedUrl"> {{baseEmbedUrl}}</a>
            </div>
          </div>

           <div class="card">
             <div class="card-header">
                <div class="card-title">Embedded Player 2 (Share Link)</div>
             </div>

            <div class="card-body">
              <a target="_blank" :href="station_info.public_page_uri"> {{station_info.public_page_uri}}</a>
            </div>
          </div>

        
          <Streams />

          <div class="row mt-5">
             
            <div class="col-12 col-md-6">
                 <h6>Horizontal Player (can be used on wordpress sidebar area)</h6>
                      <textarea 
                      id="h_embed_url" 
                      class="full-width form-control text-preformatted" 
                      spellcheck="false" 
                      style="height: 100px;">{{ embedCode }}</textarea>
                        <copy-to-clipboard-button target="#h_embed_url"></copy-to-clipboard-button>
            </div>

            <div class="col-12 col-md-6">
                 <h6>Player Preview</h6>
              <iframe
                width="100%"
                :src="embedUrl('h')"
                frameborder="0"
                style="width: 100%; border: 0;"
                :style="{ 'min-height': embedHeight }"
              ></iframe>
            </div>

          </div>

            <div class="row mt-5">
             
            <div class="col-12 col-md-6">
                 <h6>Vertical Player (can be used on wordpress sidebar area)</h6>
                            <textarea 
                            id="v_embed_url" 
                            class="full-width form-control text-preformatted" 
                            spellcheck="false" 
                            style="height: 100px;">{{ verticalEmbed }}
                            </textarea>
                        <copy-to-clipboard-button target="#v_embed_url"></copy-to-clipboard-button>
            </div>

            <div class="col-12 col-md-6">
                 <h6>Player Preview</h6>
              <iframe
                width="100%"
                :src="embedUrl('v')"
                frameborder="0"
                style="width: 100%; border: 0;"
                :style="{ 'min-height': '360px' }"
              ></iframe>
            </div>
            
          </div>


        </div>
      </div>
    </div>
  </main-content>
</template>


<script type="text/ecmascript-6">
import Streams from "@/components/common/share/ProfileStreams.vue";
import CopyToClipboardButton from '@/components/common/CopyToClipboardButton';

export default {
  methods: {

    embedUrl (dimension) {
            return this.baseEmbedUrl + '?d=' + dimension;
        },
  },

  components: {
    Streams,
    CopyToClipboardButton
  },

  computed:{
        baseEmbedUrl () {
            switch (this.selectedType) {
                case 'player':
                default:
                    return this.station_info.public_embed_uri;
            }
        },
        

        embedHeight () {
            switch (this.selectedType) {
                case 'player':
                default:
                    return '150px';
            }
        },
        embedCode () {
            return '<iframe src="' + this.embedUrl('h') + '" frameborder="0" allowtransparency="true" style="width: 100%; min-height: ' + this.embedHeight + '; border: 0;"></iframe>';
        },

        verticalEmbed () {
            return '<iframe src="' + this.embedUrl('v') + '" frameborder="0" allowtransparency="true" style="width: 100%; min-height: 360px'  + '; border: 0;"></iframe>';
        }
  },

  data() {
    return {

            selectedType: 'player',
            selectedFormat: 'h',
    };
  },
};
</script>



